import CustomStartpageElement from '@/Components/CustomStartpageElement/CustomStartpageElement';

type Constructor<T> = new(...args: any[]) => T;

export default class CustomStartpageElementRegistry {
    private static elements: { [name: string]: Constructor<any> } = {};

    public static register<T extends CustomStartpageElement>(name: string, constructor: Constructor<T>): void {
        this.elements[name] = constructor;
    }

    public static get(name: string): Constructor<CustomStartpageElement> {
        const constructor = this.elements[name];
        if (!constructor) {
            throw new Error(`Constructor for ${name} not registered`);
        }
        return constructor;
    }
}